module.exports = __webpack_public_path__ + "img/ibuprofen-chemistry.43ff7be7.png";